export const PortalsEnum = {
    lookupTypeId: 3207,
    lookupTypeName : 'PortalName'
  };
  